import Immutable from 'immutable';
import yaml from 'yaml';

import { softwareService } from '../util/mapbox-client';
import * as actionTypes from './action-types';

const getInstallerVersions = () => {
  return function(dispatch) {
    return softwareService
      .listSoftware({
        software: 'atlas-installer'
      })
      .send()
      .then(response => {
        dispatch({
          type: actionTypes.RECEIVED_ATLAS_INSTALLER_VERSIONS,
          info: response.body
        });
      })
      .catch(() => {
        // TODO handle error
      });
  };
};

const getDockerVersions = () => {
  return function(dispatch) {
    return softwareService
      .listSoftware({
        software: 'atlas-docker'
      })
      .send()
      .then(response => {
        dispatch({
          type: actionTypes.RECEIVED_ATLAS_DOCKER_VERSIONS,
          info: response.body
        });
      })
      .catch(() => {
        // TODO handle error
      });
  };
};

const getKubernetesVersions = () => dispatch => {
  return softwareService
    .getKubernetesVersions({})
    .send()
    .then(response => {
      dispatch({
        type: actionTypes.RECEIVED_KUBERNETES_VERSIONS,
        info: yaml.parse(response.body)
      });
    })
    .catch(() => {
      // TODO handle error
    });
};

const getLicenseKey = () => dispatch =>
  softwareService
    .getLicense()
    .send()
    .then(response => {
      dispatch({ type: actionTypes.RECEIVED_LICENSE_KEY, info: response.body });
    })
    .catch(() => {
      dispatch({ type: actionTypes.FAILED_TO_FETCH_LICENSE_KEY });
    });

const userLoaded = user => dispatch =>
  dispatch({ type: actionTypes.USER_LOADED, info: Immutable.fromJS(user) });

export {
  getInstallerVersions,
  getDockerVersions,
  getKubernetesVersions,
  getLicenseKey,
  userLoaded
};
